module.exports = __webpack_public_path__ + "img/underground-city.0ca2eb07.jpg";